import { Button, Typography } from "antd";
import React from "react";
import useUser from "../../../Hooks/useUser";

const TeamMembersPageHeader = ({
  openInviteModal,
}: {
  openInviteModal: (email: string | undefined) => void;
}) => {
  const { user } = useUser();

  const isAdmin = user?.role === "admin";
  return (
    <div className="team-members-page-header">
      <Typography.Title level={4} style={{ margin: 0 }} ellipsis>
        Team Members
      </Typography.Title>

      {isAdmin && (
        <Button
          id="add-team-member-button"
          type="primary"
          size="middle"
          onClick={() => openInviteModal(undefined)}
        >
          Invite Team Member
        </Button>
      )}
    </div>
  );
};

export default TeamMembersPageHeader;
